import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { BlueYonder } from '/screens/';

export default function BlueYonderPage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics integrations, logistics partners, blue yonder"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Partners | Blue Yonder"
        description="Our integration with Blue Yonder helps you move more with less by delivering real-time market rates and automated booking natively into your Blue Yonder transportation management system"
        canonical="https://loadsmart.com/integrations/blue-yonder/"
        openGraph={{
          url: 'https://loadsmart.com/integrations/blue-yonder/',
        }}
      />
      <BlueYonder />
    </>
  );
}
